module.exports = __webpack_public_path__ + "static/img/装饰15.c93acde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰15.svg
// module id = +tEQ
// module chunks = 2